/* Badeloft Bathroom Designer — five-step brief. One native contact form; steps are
   visual panels, so entered values persist across back/next without storage. */
(function () {
  'use strict';

  function initDesigner(root) {
    if (!root || root.dataset.bfDesignerReady === 'true') return;
    root.dataset.bfDesignerReady = 'true';

    var form = root.querySelector('form');
    if (!form) return; // success state — nothing to wire

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-bf-step]'));
    var maxStyles = parseInt(root.dataset.maxStyles, 10) || 3;
    var progressCurrent = root.querySelector('[data-bf-progress-current]');
    var progressTotal = root.querySelector('[data-bf-progress-total]');
    if (progressTotal) progressTotal.textContent = String(root.querySelectorAll('[data-bf-step]').length);
    var progressBar = root.querySelector('[data-bf-progress-bar]');
    var stepTitle = root.querySelector('[data-bf-step-title]');
    var notice = root.querySelector('[data-bf-notice]');
    var stylesHidden = form.querySelector('[data-bf-styles-value]');
    var bathroomsHidden = form.querySelector('[data-bf-bathrooms-value]');
    var summaryEl = root.querySelector('[data-bf-summary]');
    var current = 0;
    var submitted = false;

    function say(message) {
      if (!notice) return;
      notice.textContent = message || '';
      notice.hidden = !message;
    }

    function styleChecks() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bf-style-input]'));
    }

    function selectedStyles() {
      return styleChecks().filter(function (c) { return c.checked; });
    }

    function bathroomCounts() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bf-count]'))
        .map(function (el) {
          return { label: el.dataset.bfCountLabel, value: parseInt(el.value, 10) || 0, el: el };
        });
    }

    function syncHiddenFields() {
      if (stylesHidden) {
        stylesHidden.value = selectedStyles().map(function (c) { return c.dataset.bfStyleLabel; }).join(', ');
      }
      if (bathroomsHidden) {
        bathroomsHidden.value = bathroomCounts()
          .filter(function (b) { return b.value > 0; })
          .map(function (b) { return b.label + ' x ' + b.value; })
          .join(', ');
      }
    }

    function checkedValue(name) {
      var el = form.querySelector('input[name="' + name + '"]:checked');
      return el ? el.value : '';
    }

    function renderSummary() {
      if (!summaryEl) return;
      var rows = [
        [summaryEl.dataset.labelStyles, stylesHidden ? stylesHidden.value : ''],
        [summaryEl.dataset.labelBathrooms, bathroomsHidden ? bathroomsHidden.value : ''],
        [summaryEl.dataset.labelBudget, checkedValue('contact[Budget]')],
        [summaryEl.dataset.labelTimeline, checkedValue('contact[Timeline]')]
      ];
      summaryEl.innerHTML = '';
      rows.forEach(function (row) {
        if (!row[1]) return;
        var dt = document.createElement('dt');
        dt.textContent = row[0];
        var dd = document.createElement('dd');
        dd.textContent = row[1];
        summaryEl.appendChild(dt);
        summaryEl.appendChild(dd);
      });
    }

    function validateStep(index) {
      var step = steps[index];
      var kind = step.dataset.bfStep;
      if (kind === 'styles' && selectedStyles().length === 0) {
        return step.dataset.bfRequiredMessage;
      }
      if (kind === 'bathrooms') {
        var total = bathroomCounts().reduce(function (sum, b) { return sum + b.value; }, 0);
        if (total === 0) return step.dataset.bfRequiredMessage;
      }
      if (kind === 'budget' && !checkedValue('contact[Budget]')) {
        return step.dataset.bfRequiredMessage;
      }
      if (kind === 'timeline' && !checkedValue('contact[Timeline]')) {
        return step.dataset.bfRequiredMessage;
      }
      return '';
    }

    function show(index, skipScroll) {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function (step, i) { step.hidden = i !== current; });
      if (progressCurrent) progressCurrent.textContent = String(current + 1);
      if (progressBar) progressBar.style.width = (((current + 1) / steps.length) * 100) + '%';
      if (stepTitle) stepTitle.textContent = steps[current].dataset.bfTitle || '';
      say('');
      if (steps[current].dataset.bfStep === 'contact') {
        syncHiddenFields();
        renderSummary();
      }
      if (skipScroll) return;
      var heading = steps[current].querySelector('[data-bf-step-heading]');
      if (heading) heading.focus({ preventScroll: true });
      root.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'start' });
    }

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // Style cards: enforce the selection limit.
    styleChecks().forEach(function (input) {
      input.addEventListener('change', function () {
        var picked = selectedStyles();
        if (picked.length > maxStyles) {
          input.checked = false;
          say(root.dataset.limitMessage.replace('[count]', String(maxStyles)));
          return;
        }
        say('');
        syncHiddenFields();
      });
    });

    // Bathroom count steppers.
    Array.prototype.slice.call(root.querySelectorAll('[data-bf-stepper]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var field = btn.parentElement.querySelector('[data-bf-count]');
        if (!field) return;
        var value = parseInt(field.value, 10) || 0;
        value += btn.dataset.bfStepper === 'up' ? 1 : -1;
        field.value = String(Math.max(0, Math.min(value, 9)));
        syncHiddenFields();
      });
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-bf-count]')).forEach(function (field) {
      field.addEventListener('change', function () {
        var value = parseInt(field.value, 10);
        if (isNaN(value) || value < 0) value = 0;
        if (value > 9) value = 9;
        field.value = String(value);
        syncHiddenFields();
      });
    });

    // Navigation.
    Array.prototype.slice.call(root.querySelectorAll('[data-bf-next]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var problem = validateStep(current);
        if (problem) { say(problem); return; }
        show(current + 1);
      });
    });
    Array.prototype.slice.call(root.querySelectorAll('[data-bf-back]')).forEach(function (btn) {
      btn.addEventListener('click', function () { show(current - 1); });
    });

    // Guard submit: full validation, sync hidden fields, prevent double submission.
    form.addEventListener('submit', function (event) {
      for (var i = 0; i < steps.length; i += 1) {
        var problem = validateStep(i);
        if (problem) {
          event.preventDefault();
          show(i);
          say(problem);
          return;
        }
      }
      if (submitted) { event.preventDefault(); return; }
      submitted = true;
      syncHiddenFields();
      var submit = form.querySelector('[type="submit"]');
      if (submit) {
        submit.setAttribute('aria-disabled', 'true');
        submit.classList.add('is-waiting');
      }

      // Paid design service: when every selected bathroom type carries a
      // checkout variant id, send the brief as a background lead email and
      // take the customer straight to a checkout holding one design service
      // per bathroom. Any type missing its id falls back to the plain
      // brief submission above.
      var picked = bathroomCounts().filter(function (b) { return b.value > 0; });
      var payable = picked.length > 0 && picked.every(function (b) {
        return /^\d+$/.test(b.el.dataset.bfVariantId || '');
      });
      if (!payable) return;

      event.preventDefault();
      try {
        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(form),
          keepalive: true
        }).catch(function () {});
      } catch (e) { /* lead email is best-effort; checkout still proceeds */ }

      var items = picked.map(function (b) {
        return b.el.dataset.bfVariantId + ':' + b.value;
      }).join(',');
      var params = [];
      function attr(name, value) {
        if (value) params.push('attributes[' + name + ']=' + encodeURIComponent(value));
      }
      attr('Styles', stylesHidden ? stylesHidden.value : '');
      attr('Bathrooms', bathroomsHidden ? bathroomsHidden.value : '');
      attr('Budget', checkedValue('contact[Budget]'));
      attr('Timeline', checkedValue('contact[Timeline]'));
      var notesEl = form.querySelector('textarea[name="contact[Notes]"]');
      if (notesEl && notesEl.value) attr('Notes', notesEl.value.slice(0, 250));
      var params_qs = params.join('&');
      var emailEl = form.querySelector('input[name="contact[email]"]');
      if (emailEl && emailEl.value) {
        params_qs += (params_qs ? '&' : '') + 'checkout[email]=' + encodeURIComponent(emailEl.value);
      }
      window.location.href = '/cart/' + items + (params_qs ? '?' + params_qs : '');
    });

    show(0, true);
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-bf-designer]')).forEach(initDesigner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
